(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tab-links .button');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        console.log('click');
        e.preventDefault();
        const currentAttrValue = this.getAttribute('href');

        // Show/Hide Tabs
        document.querySelector('.tab.active').classList.remove('active');
        document.querySelector(currentAttrValue).classList.add('active');

        // Change/remove current tab to active
        document.querySelector('.tab-links .active').classList.remove('active');
        this.parentElement.classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-slider"] && !Shopify.designMode) return;
  try {
    
  const slides_per_view = document.querySelector('.swiper').getAttribute('data-slides-per-view');
  document.addEventListener('DOMContentLoaded', function () {
    const swiperContainers = document.querySelectorAll('.swiper');

    swiperContainers.forEach((container) => {
      const buttonPrev = container.querySelector('.swiper-prev');
      const buttonNext = container.querySelector('.swiper-next');

      const swiper = new Swiper(container, {
        slidesPerView: slides_per_view,
        spaceBetween: 32,
        grabCursor: true,
        centeredSlides: true,
        speed: 5,
        direction: 'horizontal',
        loop: true,
        navigation: {
          prevEl: buttonPrev,
          nextEl: buttonNext,
        },
        pagination: {
          el: '.swiper-pagination',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
        },
        breakpoints: {
          0: {
            slidesPerView: 1.25,
            slidesPerGroup: 1,
            spaceBetween: 16,
          },
          480: {
            slidesPerView: 2.5,
            slidesPerGroup: 1,
            spaceBetween: 24,
          },
          767: {
            slidesPerView: 3.5,
            slidesPerGroup: 1,
            spaceBetween: 32,
          },
          992: {
            slidesPerView: slides_per_view,
            slidesPerGroup: 1,
            spaceBetween: 32,
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-slider"] && !Shopify.designMode) return;
  try {
    
  // const slides_per_view = '{{ slides_per_view | json }}';
  const slides_per_view = document.querySelector('.swiper').getAttribute('data-slides-per-view');
  console.log(slides_per_view);
  document.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.swiper', {
      // Optional parameters
      slidesPerView: slides_per_view,
      spaceBetween: 32,
      grabCursor: true,
      centeredSlides: true,
      speed: 1000,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      direction: 'horizontal',
      loop: true,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      breakpoints: {
        0: {
          /* when window >=0px - webflow mobile portriat */

          slidesPerView: 1.25,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
        480: {
          /* when window >=0px - webflow mobile landscape */

          slidesPerView: 2.5,
          slidesPerGroup: 1,
          spaceBetween: 24,
        },
        767: {
          /* when window >= 767px - webflow tablet */

          slidesPerView: 3.5,
          slidesPerGroup: 1,
          spaceBetween: 32,
        },
        992: {
          /* when window >= 988px - webflow desktop */

          slidesPerView: slides_per_view,
          slidesPerGroup: 1,
          spaceBetween: 32,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swiper-slider"] && !Shopify.designMode) return;
  try {
    
  // const slides_per_view = '{{ slides_per_view | json }}';
  const slides_per_view = document.querySelector('.swiper').getAttribute('data-slides-per-view');
  console.log(slides_per_view);
  document.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.swiper', {
      // Optional parameters
      slidesPerView: slides_per_view,
      spaceBetween: 16,
      grabCursor: true,
      centeredSlides: true,
      speed: 1000,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      direction: 'horizontal',
      loop: true,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      breakpoints: {
        0: {
          /* when window >=0px - webflow mobile portriat */

          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 20,
        },
        480: {
          /* when window >=0px - webflow mobile landscape */

          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 24,
        },
        767: {
          /* when window >= 767px - webflow tablet */

          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 32,
        },
        992: {
          /* when window >= 988px - webflow desktop */

          slidesPerView: slides_per_view,
          slidesPerGroup: 1,
          spaceBetween: 32,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
